import BaseDialog from '@/components/BaseDialog'

/**
 * 添加产品
 * @param {*} param0 
 * @returns 
 */
export function addAppModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./addAppModal/'),
        options: {
            width: '900px',
            title: '添加产品',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
/**
 * 编辑产品
 * @param {*} param0 
 * @returns 
 */
export function editAppModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./edit'),
        options: {
            width: '800px',
            title: '编辑产品',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
/**
 * 验证提示框
 * @param {*} param0 
 * @returns 
 */
export function errDataTipModal({ props, cbs, width }) {
    return new BaseDialog({
        component: ()=>import('./errDataTipModal'),
        options: {
            width: width || '800px',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        slots: {
            title(h) {
                return h('span', 
                    {
                        style: {
                            color: 'red',
                            fontSize: '18px'
                        }
                    },props.title || '校验失败'
                )
            }
        }
    })
}